import {  useEffect, useState } from 'react';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBullhorn, faGraduationCap, faBars, faBookOpen, faUser, faSignOutAlt, faHouseUser, faPen, faFile, faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { withRouter } from "react-router";
import { useHistory } from "react-router";
import { Util } from '../../config/Util';
import './SidePanel.css';
import axios from 'axios';
import { API } from '../../config/API';

function SidePanel( { collapsed, setCollapsed } ) {
  const history = useHistory();
  const [isFacilitator, setIsFacilitator] = useState(false);
  const [isCILead, setIsCILead] = useState(false);
  const [ibtikarEnabled, setIbtikarEnabled] = useState(false);
  const [highlightIbtikar, setHighlightIbtikar] = useState(false);
  
  const fetchIbtikarStatus = async (userId) => {
    if (!userId) return;
    try {
      const resp = await axios.get(API.myIdeas, { params: { userId } });
      if (resp && resp.data && resp.data.status === 'S' && Array.isArray(resp.data.ideas)) {
        const ideas = resp.data.ideas;
        const hasActiveImplementation = ideas.some(
          idea => Number(idea.assignee) === Number(userId) && 
                  idea.status && 
                  String(idea.status).toLowerCase().includes('implementation')
        );
        setHighlightIbtikar(hasActiveImplementation);
      }
    } catch (e) {
      console.error('Error fetching Ibtikar status in sidebar:', e);
    }
  };

  const readFlags = () => {
    try {
      const userData = Util.getFromSession('userData') || {};
      const authData = Util.getFromSession('auth') || {};
      console.log('SidePanel userData:', userData);
      const facilitatorFlag = !!(userData?.facilitator === true || (userData?.data && userData.data.facilitator === true));
      const ciLeadFlag = !!(userData?.cilead === true || (userData?.data && userData.data.cilead === true));
      const ibtikarFlag = authData?.ibtikarEnable;
      setIsFacilitator(facilitatorFlag);
      setIsCILead(ciLeadFlag);
      setIbtikarEnabled(ibtikarFlag);

      const userId = authData && authData.id ? authData.id : Util.userId;
      if (ibtikarFlag && userId) {
        fetchIbtikarStatus(userId);
      } else {
        setHighlightIbtikar(false);
      }
    } catch (e) {
      setIsFacilitator(false);
      setIsCILead(false);
      setIbtikarEnabled(false);
      setHighlightIbtikar(false);
    }
  };
  useEffect(() => {
    readFlags();
     const handler = () => readFlags();
    window.addEventListener('userDataUpdated', handler);
    return () => window.removeEventListener('userDataUpdated', handler);
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    history.push("/landing");
  };

  return (
    <div style={{ display: 'flex', height: '100%' }} className="admin-side-panel-wrapper">
      <Sidebar 
        collapsed={collapsed} 
        backgroundColor='rgba(29, 41, 61, 0.95)'
      >
        <button onClick={() => setCollapsed(!collapsed)} className="btn toggle-btn sb-button">
          <FontAwesomeIcon icon={faBars} />
        </button>
        <Menu>
          <MenuItem onClick={() => history.push("/admin/overview")} icon={<FontAwesomeIcon icon={faHouseUser} />} > Home</MenuItem>
          <MenuItem onClick={() => history.push("/admin/communication")} icon={<FontAwesomeIcon icon={faBullhorn} />} > Communication</MenuItem>
          <MenuItem onClick={() => history.push("/admin/assessment")} icon={<FontAwesomeIcon icon={faGraduationCap} />} > Assessment</MenuItem>
          <MenuItem onClick={() => history.push("/admin/training")} icon={<FontAwesomeIcon icon={faBookOpen} />} > Training</MenuItem>
          {ibtikarEnabled && (
            <SubMenu icon={<FontAwesomeIcon icon={faLightbulb} style={highlightIbtikar ? { color: '#F15c2a' } : {}} />} label="Ibtikar">
              {isCILead && (
                <MenuItem onClick={() => history.push("/admin/ibtikar/leader-dashboard")}> Leader Dashboard </MenuItem>
              )}
              {isFacilitator && (
                <MenuItem onClick={() => history.push("/admin/ibtikar/facilitation")}> Facilitation </MenuItem>
              )}
              <MenuItem onClick={() => history.push("/admin/ibtikar/submissions")}> Submissions </MenuItem>
              <MenuItem onClick={() => history.push("/admin/ibtikar/implementation")}> Implementation </MenuItem>
            </SubMenu>
          )}
          <MenuItem onClick={() => history.push("/admin/user")} icon={<FontAwesomeIcon icon={faUser} />} > Users</MenuItem>
          <MenuItem onClick={() => history.push("/admin/report")} icon={<FontAwesomeIcon icon={faFile} />} > Report</MenuItem>
          <MenuItem onClick={() => history.push("/admin/evaluation")} icon={<FontAwesomeIcon icon={faPen} />} > Evaluation</MenuItem>
        </Menu>

        <div style={{ marginTop: 'auto', position: 'absolute', bottom: 0, width: '100%', borderTop: 'solid 1px grey' }}>
          <Menu>
            <MenuItem onClick={handleLogout} icon={<FontAwesomeIcon icon={faSignOutAlt} />} > Logout</MenuItem>
          </Menu>
        </div>
      </Sidebar>

    </div>
  );
}

export default withRouter(SidePanel);